<template>
  <Footer>
    <cell-group v-if="list.length>0" class="formstyle" :border="false">
      <template v-for="item in list">
        <div class="title" v-if="+item.type === 1 || +item.type === 3">
          <div>{{item.show_name}}</div>
          <div v-html="item.desc"></div>
        </div>
        <div class="title" v-if="+item.type === 4">
          <!-- <div>{{item.show_name}}</div> -->
          <div v-html="item.show_name"></div>
          <!-- <div v-html="item.desc"></div> -->
        </div>
        <field
          v-if="+item.type === 1 || +item.type === 2"
          v-model="ruleForm[item.key_name]"
          clearable
          :required="item.required == 1"
          @input="changeicon(item,ruleForm[item.key_name])"
          :label="'评分最高'+item.max+'分'"
          placeholder="请输入"
          :error="icon[item.key_name]==='fail'"
          :type="+item.type===2?'textarea':'number'"
          autosize
        />
        <field :required="item.required == 1" v-else-if="+item.type === 3" name="radio" label="评分">
          <template #input>
            <van-radio-group v-model="ruleForm[item.key_name]"  @change="changeicon(item,ruleForm[item.key_name])" direction="horizontal">
              <van-radio :name="citem.key" v-for="citem in item.options">{{citem.value}}</van-radio>
            </van-radio-group>
          </template>
        </field>
        <field name="checkboxGroup" :required="item.required == 1" v-else-if="+item.type === 4" label="评分">
          <template #input>
            <van-checkbox-group v-model="ruleForm[item.key_name]"  @change="changeicon(item,ruleForm[item.key_name])">
              <van-checkbox :name="citem.value" v-for="citem in item.options" style="padding-bottom:.2rem">{{citem.value}}</van-checkbox>
            </van-checkbox-group>
          </template>
        </field>

        <cell
          :class="{'van-cell--required':+item.required===1,'van-field--error':icon[item.key_name]==='fail'}"
          v-else-if="+item.type===10 || +item.type===5"
        >
          <template slot="label">
            <div class="up">
              <Upload ref="upload" @setUrl="setUrl" value :keyname="item.key_name" />
            </div>
              
          </template>
          <div
            slot="title"
            :style="{color: icon[item.key_name]==='fail'?'red':''}"
          >{{item.placeholder?item.placeholder:'请'+item.show_name}}</div>
        </cell>

        <cell
          :class="{'van-cell--required':+item.required===1,'van-field--error':icon[item.key_name]==='fail'}"
          v-else-if="+item.type===11"
        >
          <template slot="label">
            <UploadImage :item="item" @setUrl="setUrl" />
          </template>
          <div
            slot="title"
            :style="{color: icon[item.key_name]==='fail'?'red':''}"
          >{{item.placeholder?item.placeholder:'请'+item.show_name}}</div>
        </cell>

        <field
          v-else
          v-model="ruleForm[item.key_name]"
          clearable
          readonly
          :required="item.required == 1"
          label="评分"
          placeholder="请输入"
          @click="onOpen(item,ruleForm[item.key_name])"
          right-icon="arrow"
          :error="icon[item.key_name]==='fail'"
        />
        
        <Icon
          size="16px"
          slot="right-icon"
          v-if="showic[item.key_name]"
          :name="icon[item.key_name]"
          :color="color[item.key_name]"
        />
      </template>
    </cell-group>

    <Popup v-model="show" position="bottom" :overlay="true">
      <Picker
        v-if="type==9"
        show-toolbar
        :columns="options"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
      <Area v-else-if="type==8" :area-list="areaList" @cancel="onCancel" @confirm="onConfirm" />
      <datetime-picker
        v-else
        :min-date="minDate"
        type="date"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </Popup>

    <Cell slot="footbar" >
      <div style="display: flex;
    align-items: center;
    justify-content: space-between;">
        <Button
          round
          @click="signUp"
          class="mvbutton"
          style="width: 3rem;height:.8rem"
        >提交</Button>
        <Button
          round
          plain
          type="info"
          @click="signUp2"
          style="width: 3rem;height:.8rem"
        >暂存</Button>
      </div>
      
      
    </Cell>
  </Footer>
</template>

<script>
import Footer from "../footbar/index";
import Upload from "../Upload/index";
import UploadImage from "../UploadImage/index";
import "./index.less";
import areadeil from "./area.js";
import {
  CellGroup,
  Cell,
  Button,
  Field,
  Picker,
  Popup,
  Area,
  Icon,
  Checkbox,
  DatetimePicker,
  Stepper,
  RadioGroup,
  Radio,
  CheckboxGroup
} from "vant";
import { mapMutations, mapState } from "vuex";

export default {
  name: "Form",
  components: {
    Upload,
    Footer,
    Field,
    CellGroup,
    Cell,
    Button,
    Picker,
    Popup,
    Area,
    Icon,
    VanCheckbox: Checkbox,
    VanCheckboxGroup: CheckboxGroup,
    DatetimePicker,
    UploadImage,
    VanStepper: Stepper,
    VanRadioGroup: RadioGroup,
    VanRadio: Radio
  },
  data() {
    return {
      show: false,
      showstatement: false,
      statementchecked: false,
      checked: false,
      options: [],
      onedata: [],
      ruleForm: {},
      showterm: false,
      icon: {},
      color: {},
      showic: {},
      agree: false,
      type: 0,
      currentDate: false,
      minDate: new Date(1919, 0, 0),
      areaList: areadeil,
      shenfen: true,
      ishide: false
    };
  },
  filters: {},
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    }
  },
  watch: {
    list: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  methods: {
    signUp: function (e) {
      console.log(this.list)
      let go = true;
      this.list.forEach((value, index) => {
        this.$set(this.showic, value.key_name, true);
        for (let i in this.ruleForm) {
          if (value.key_name == i) {
            if (value.required == 1) {
              value.value = this.ruleForm[i];
              var reg =
                eval(value.rules) == null ? undefined : eval(value.rules);
              var pattern = new RegExp(reg);
              var isshow = pattern.test(value.value);
              if(value.type == 1 && value.max && value.value>value.max) {
                isshow = false
              }
              var name = isshow == true ? "checked" : "fail";
              
              var color = isshow == true ? "#57bd6b" : "#ec5351";            
              this.$set(this.icon, value.key_name, name);
              this.$set(this.color, value.key_name, color);
            } else {
              value.value = this.ruleForm[i];
              var name = "checked";
              var color = "#57bd6b";
              this.$set(this.icon, value.key_name, name);
              this.$set(this.color, value.key_name, color);
            }
          }
        }
      });
      this.list.forEach((value, index) => {
        if (!value.value && value.value !== 0) {
          if (value.required == 1 && !this.ishide) {
            this.$toast.fail(value.show_name+'提交有误')
            this.$set(this.icon, value.key_name, "fail");
            this.$set(this.color, value.key_name, "#ec5351");
          } else {
            
            this.$set(this.icon, value.key_name, "checked");
            this.$set(this.color, value.key_name, "#57bd6b");
          }
        }
      });
      for (let j in this.icon) {
        if (this.icon[j] == "fail") {
          go = false;
        }
      }
      if (go == true) {
        this.$emit("submit", this.list);
      }
    },
    signUp2: function (e) {
      let go = true;
      this.list.forEach((value, index) => {
        this.$set(this.showic, value.key_name, true);
        for (let i in this.ruleForm) {
          if (value.key_name == i) {
            if (value.required == 1) {
              value.value = this.ruleForm[i];
              if (this.ishide && !value.value && value.type != 3){
                value.value = 0
              }
              var reg =
                eval(value.rules) == null ? undefined : eval(value.rules);
              var pattern = new RegExp(reg);
              var isshow = pattern.test(value.value);
              var name = isshow == true ? "checked" : "fail";
              var color = isshow == true ? "#57bd6b" : "#ec5351";            
              this.$set(this.icon, value.key_name, name);
              this.$set(this.color, value.key_name, color);
            } else {
              value.value = this.ruleForm[i];
              var name = "checked";
              var color = "#57bd6b";
              this.$set(this.icon, value.key_name, name);
              this.$set(this.color, value.key_name, color);
            }
          }
        }
      });
      this.list.forEach((value, index) => {
        if (!value.value && value.value !== 0) {
          if (value.required == 1 && !this.ishide) {
            this.$toast.fail(value.show_name+'提交有误')
            this.$set(this.icon, value.key_name, "fail");
            this.$set(this.color, value.key_name, "#ec5351");
          } else {
            
            this.$set(this.icon, value.key_name, "checked");
            this.$set(this.color, value.key_name, "#57bd6b");
          }
        }
      });
      this.$emit("submit2", this.list);
      // for (let j in this.icon) {
      //   if (this.icon[j] == "fail") {
      //     go = false;
      //   }
      // }
      // if (go == true) {
      //   this.$emit("submit2", this.list);
      // }
    },
    onOpen(e, val) {
      this.onedata = e;
      this.show = true;
      if (e.type == 7) {
        this.type = 7;
      } else if (e.type == 8) {
        this.type = 8;
      } else {
        this.type = e.type;
        this.options = [];
        for (let i = 0, len = e.options.length; i < len; i++) {
          this.options.push(e.options[i].value);
        }
      }
    },
    goblack(){
      this.$emit("goto");
    },
    onCancel(e) {
      this.show = false;
    },
    onConfirm(event, index) {
      if (this.type == 7) {
        event = this.cf.formatTime(event);
      } else if (this.type == 8) {
        event = event[0].name + "," + event[1].name + "," + event[2].name;
      }
      this.$set(this.ruleForm, this.onedata.key_name, event);
      this.changeicon(this.onedata, event);
      this.show = false;
    },
    setUrl: function (res, key) {
      console.log(res,key)
      this.$set(this.ruleForm, key, res);
      this.changeicon({ key_name: key }, res);
    },
    changeicon(item, val) {
      if(item.type == 3 && val == 1) {
        this.ishide = true
      } else if (item.type == 3 && val == 0) {
        this.ishide = false
      }
      this.$set(this.showic, item.key_name, true);
      var reg = eval(item.rules) == null ? undefined : eval(item.rules);
      var pattern = new RegExp(reg);
      var isshow = val == "" ? false : pattern.test(val);
      if(item.type == 1 && item.max && val>item.max) {
        isshow = false
      }
      var name = isshow == true ? "checked" : "fail";
      var color = isshow == true ? "#57bd6b" : "#ec5351";
      this.$set(this.icon, item.key_name, name);
      this.$set(this.color, item.key_name, color);
    },
    setOptions(list) {
      list.forEach((value, index) => {
        if (!!value.value) {
          if(value.type == 4) {
            this.$set(this.ruleForm, value.key_name, [value.options[0].value]);
          } else {
            this.$set(this.ruleForm, value.key_name, '');
          }
          
        }
        if (value.type == 3 || value.type == 9) {
          if (typeof value.options == "string")
            value.options = JSON.parse(value.options);

          if (!!value.value) {
            let selectedvalue = value.options.filter((item) => {
              return item.value == value.value;
            });
            if (selectedvalue.length == 0) {
              this.$set(this.ruleForm, value.key_name, value.options[0].value);
            } else {
              this.$set(this.ruleForm, value.key_name, selectedvalue[0].value);
            }
          } else {
            this.$set(this.ruleForm, value.key_name, value.options[0].value);
          }
        }
      });
    }
  },
  mounted() {
    this.setOptions(this.list);
    
  },
};
</script>
